import React from "react";
import Hero from "./hero/Hero";

import Menu from "../features/menuitems/Menu";
import Aboutus from "../features/shop/Aboutus";

const Index = () => {
  return (
    <div className="overflow-x-hidden">
      <Hero />
      <Aboutus />
      <Menu />
    </div>
  );
};

export default Index;
